import { AccessTime } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { TimelineRecord } from 'src/types/convocation-summary';

import {
  formatCountdown,
  fromCivilDate,
  getDaysUntil,
  getTimelineEventDate,
} from '../timelineCalendarDates';

interface TimelineFutureEventIndicatorProps {
  record: Pick<TimelineRecord, 'datareferencia' | 'dataentrega'>;
}

const formatEventDate = (date: string) =>
  format(fromCivilDate(date), "dd 'de' MMM 'de' yyyy", {
    locale: ptBR,
  }).replace(/\./g, '');

export default function TimelineFutureEventIndicator({
  record,
}: TimelineFutureEventIndicatorProps) {
  const eventDate = getTimelineEventDate(record);

  if (!eventDate) return null;

  const countdown = formatCountdown(getDaysUntil(eventDate.date));

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      alignItems="center"
      data-testid="timeline-future-event-indicator"
      sx={{ columnGap: 0.5, minWidth: 0 }}>
      <AccessTime aria-hidden="true" fontSize="small" color="action" />
      <Typography variant="body2" color="text.secondary">
        {eventDate.kind === 'delivery' && 'Entrega · '}
        <time dateTime={eventDate.date}>{formatEventDate(eventDate.date)}</time>
      </Typography>
      {countdown && (
        <Typography
          variant="body2"
          color="text.primary"
          fontWeight={600}
          noWrap>
          · {countdown}
        </Typography>
      )}
    </Stack>
  );
}
